<template>
    <div class="help-widget" ref="helpWidget">
        <!-- Help Button -->
        <transition name="fade">
            <div
                v-if="!isOpen"
                class="help-button"
                @click="toggleWidget"
                ref="helpButton"
            >
                <div class="background-circles">
                    <div class="circle circle-1"></div>
                    <div class="circle circle-2"></div>
                    <div class="circle circle-3"></div>
                </div>
                <div class="help-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_4950_6606)">
                            <path d="M12 0C13.6602 2.58042e-06 15.2201 0.312172 16.6797 0.947266C18.1392 1.58236 19.4095 2.42902 20.4902 3.50977C21.571 4.59052 22.4288 5.86074 23.0527 7.32031C23.6878 8.77992 24 10.3398 24 12C24 13.6602 23.6767 15.2201 23.0527 16.6797C22.4176 18.1393 21.571 19.4095 20.4902 20.4902C19.4095 21.571 18.1393 22.4288 16.6797 23.0527C15.2201 23.6878 13.6602 24 12 24C10.3398 24 8.77992 23.6767 7.32031 23.0527C5.86074 22.4176 4.59052 21.571 3.50977 20.4902C2.42902 19.4095 1.58236 18.1392 0.947266 16.6797C0.312172 15.2201 2.5804e-06 13.6602 0 12C0 10.3398 0.323311 8.77992 0.947266 7.32031C1.58236 5.86074 2.42901 4.59052 3.50977 3.50977C4.59052 2.42901 5.86074 1.58236 7.32031 0.947266C8.77992 0.312169 10.3398 0 12 0ZM12 1.62695C10.5739 1.62695 9.21468 1.90563 7.9668 2.44043C6.70788 2.98633 5.59368 3.73257 4.66895 4.65723C3.74422 5.58195 2.99712 6.69613 2.45117 7.95508C1.90521 9.20299 1.6377 10.5631 1.6377 11.9893C1.63775 13.4153 1.91641 14.7747 2.45117 16.0225C2.99713 17.2815 3.74419 18.3956 4.66895 19.3203C5.59369 20.245 6.70785 20.9912 7.9668 21.5371C9.2147 22.0831 10.5738 22.3506 12 22.3506C13.4262 22.3506 14.7853 22.0719 16.0332 21.5371C17.2922 20.9912 18.4063 20.245 19.3311 19.3203C20.2558 18.3956 21.0029 17.2815 21.5488 16.0225C22.0947 14.7747 22.3623 13.4153 22.3623 11.9893C22.3623 10.5631 22.0836 9.20299 21.5488 7.95508C21.0029 6.69613 20.2558 5.58196 19.3311 4.65723C18.4063 3.73256 17.2921 2.98634 16.0332 2.44043C14.7853 1.89449 13.4262 1.62696 12 1.62695ZM11.8213 16.6904C12.2001 16.6904 12.5119 16.8137 12.7793 17.0811C13.0467 17.3485 13.1699 17.6602 13.1699 18.0391C13.1699 18.4178 13.0355 18.7297 12.7793 18.9971C12.5231 19.2643 12.2 19.3867 11.8213 19.3867C11.4426 19.3867 11.1306 19.2644 10.8633 18.9971C10.5959 18.7409 10.4737 18.4178 10.4736 18.0391C10.4736 17.6603 10.596 17.3484 10.8633 17.0811C11.1195 16.8137 11.4426 16.6905 11.8213 16.6904ZM12.0332 4.5791C13.203 4.5791 14.206 4.89126 15.0527 5.50391C15.8772 6.10553 16.2783 6.9525 16.2783 8.08887C16.2783 8.74625 16.1338 9.32598 15.833 9.79395C15.5211 10.2841 15.0756 10.819 14.5186 11.376C13.7165 12.1335 13.237 12.7239 13.0586 13.1807C12.9138 13.5594 12.6351 14.2392 12.6016 14.8965H10.752L10.7412 14.9082C10.7746 13.9166 11.0755 13.0585 11.2314 12.7354C11.432 12.3231 12.0117 11.7102 12.9365 10.8857C13.3486 10.5404 13.6942 10.1618 13.9727 9.76074C14.2735 9.3262 14.418 8.85784 14.418 8.35645C14.418 7.82166 14.2175 7.3314 13.8164 6.88574C13.4042 6.44006 12.8024 6.2168 12.0225 6.2168C11.1422 6.2168 10.4736 6.48471 10.0391 7.01953C9.72712 7.39833 9.49347 7.75521 9.34863 8.10059L7.73242 7.46484C8.03326 6.70725 8.5243 6.05023 9.18164 5.49316C9.90577 4.88051 10.8636 4.57917 12.0332 4.5791Z" fill="#F7F7F7"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_4950_6606">
                                <rect width="24" height="24" fill="white"/>
                            </clipPath>
                        </defs>
                    </svg>
                </div>
            </div>
            <div v-else @click="toggleWidget" class="help-close-button">
                <div class="background-circles">
                    <div class="circle circle-4"></div>
                </div>
                <div class="help-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 5.64056L13.6406 11.9999L20 18.3593L18.3594 19.9999L12 13.6406L5.64062 19.9999L4 18.3583L10.3584 11.999L4 5.64056L5.64062 3.99994L11.999 10.3583L18.3594 3.99994L20 5.64056Z" fill="#DADDE6"/>
                    </svg>
                </div>
            </div>
        </transition>


        <!-- Help Panel -->
        <transition name="slide-up">
            <div v-if="isOpen" class="help-panel" ref="helpPanel">
                <div class="help-panel-container">
                    <!-- Header -->
                    <div class="help-header">
                        <p class="help-title">Օգնություն
                            <button type="button"
                                    class="close "
                                    @click="toggleWidget" aria-label="Close">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20 5.64062L13.6406 12L20 18.3594L18.3594 20L12 13.6406L5.64062 20L4 18.3584L10.3584 11.999L4 5.64062L5.64062 4L11.999 10.3584L18.3594 4L20 5.64062Z" fill="#2D3036"/>
                                </svg>
                            </button>
                        </p>

                        <span class="help-description">
            Կազմակերպիր գնման գործընթացները արագ և ճշգրիտ
          </span>
                    </div>

                    <!-- Content -->
                    <div class="help-content-container little-scroll">
                        <!-- Loading State -->
                        <div v-if="loading" class="loading-state">
                            <div class="spinner"></div>
                            <p>Տվյալները բեռնվում են...</p>
                        </div>

                        <!-- No Questions -->
                        <div v-else-if="!questions.length" class="no-questions">
                            <i class="fas fa-info-circle"></i>
                            <p>Այս էջի համար հարցեր չկան</p>
                        </div>

                        <!-- Questions List -->
                        <div v-else class="questions-list">

                            <div class="help-content" id="accordion" v-for="(question, index) in questions" :key="index">
                                <b-card no-body class="my-3">
                                    <b-card-header header-tag="header" class="w-100 m-0 card-header help-content border-0 help-content-main-block p-0" :id="`${'heading_' + index}`" role="tab">
                                        <div v-b-toggle="`${'collapse_' + index}`"  class="help-content-block d-flex align-items-center justify-content-between" data-toggle="collapse" :data-target="`${'#collapse_' + index}`" aria-expanded="false" :aria-controls="`${'#collapse_' + index}`">
                                            <h1 class="help-content-header mr-5 active mb-0">{{ question.question }}</h1>
                                            <img src="/assets/landing/images/more.svg" alt="arrow icon" class="help-content-more-arrow active">
                                        </div>
                                    </b-card-header>
                                    <b-collapse :id="`${'collapse_' + index}`" class="collapse" accordion="my-accordion" role="tabpanel">
                                        <b-card-body>
                                            <transition name="expand">
                                                <div
                                                    class="question-answer"
                                                >

                                                    <!-- Media Content -->
                                                    <div v-if="question.has_media" class="answer-media">
                                                        <!-- Image -->
                                                        <div v-if="question.answer_image" class="media-item">
                                                            <img
                                                                :src="question.answer_image"
                                                                :alt="'Պատկեր - ' + question.question"
                                                                class="answer-image"
                                                                @click="openImageModal(question.answer_image)"
                                                            >
                                                        </div>

                                                        <!-- Video -->
                                                        <div v-if="question.answer_video" class="media-item">
                                                            <video
                                                                :src="question.answer_video"
                                                                controls
                                                                class="answer-video"
                                                                preload="metadata"
                                                            >
                                                                Ձեր բրաուզերը չի աջակցում վիդեո նվագարկմանը
                                                            </video>
                                                        </div>

                                                        <!-- Audio -->
                                                        <div v-if="question.answer_audio" class="media-item">
                                                            <audio
                                                                :src="question.answer_audio"
                                                                controls
                                                                class="answer-audio"
                                                                preload="metadata"
                                                            >
                                                                Ձեր բրաուզերը չի աջակցում աուդիո նվագարկմանը
                                                            </audio>
                                                        </div>
                                                    </div>
                                                    <!-- Text Answer -->
                                                    <div v-if="question.answer_text" class="answer-text">
                                                        <div v-html="question.answer_text"></div>
                                                    </div>
                                                </div>
                                            </transition>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </div>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="help-footer">
                        <p class="help-footer-title">Ռեսուրսներ</p>
                        <div class="d-flex flex-column">
                            <!--              <div class="help-footer-item">-->
                            <!--                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
                            <!--                  <path d="M11.7422 4.9963C11.9143 4.93183 12.0867 4.93181 12.2588 4.9963L21.9521 8.23848C22.1889 8.32465 22.3826 8.50762 22.458 8.75509V8.74434C22.598 9.1643 22.372 9.61694 21.9521 9.75704L18.7422 10.8264V18.1145C18.7422 18.6314 18.3226 19.0519 17.8057 19.052H6.19531C5.67849 19.0518 5.25879 18.6313 5.25879 18.1145V10.8264L3.11523 10.1125V16.424H1.5V8.99239C1.5 8.63704 1.72581 8.33549 2.04883 8.22774L11.7422 4.9963ZM15.8994 11.7707L12.2588 12.9885C12.0867 13.0422 11.9143 13.0422 11.7422 12.9885L8.10156 11.7707L6.87402 11.3645V17.4358H17.127V11.3645L15.8994 11.7707ZM4.86035 9.00313L12 11.383L19.1406 9.00313L12 6.62325L4.86035 9.00313Z" fill="#006BE6"/>-->
                            <!--                </svg>-->
                            <!--                <span class="help-description">-->
                            <!--                  Ուսումնական կենտրոն-->
                            <!--                </span>-->
                            <!--              </div>-->
                            <div @click="()=>{toggleWidget();$router.push('/help')}" class="help-footer-item">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M11.1914 16.0399H12.7268V11.0298H11.1914V16.0399Z" fill="#006BE6"/>
                                    <path d="M12.8076 7.87891H11.1914V9.49507H12.8076V7.87891Z" fill="#006BE6"/>
                                    <path d="M12 4C7.55556 4 4 7.55556 4 12C4 16.4444 7.55556 20 12 20C16.4444 20 20 16.4444 20 12C20 7.55556 16.3636 4 12 4ZM12 18.303C8.44444 18.303 5.61616 15.4747 5.61616 12C5.61616 8.52525 8.44444 5.61616 12 5.61616C15.5556 5.61616 18.3838 8.44444 18.3838 12C18.3838 15.5556 15.4747 18.303 12 18.303Z" fill="#006BE6"/>
                                </svg>
                                <span class="help-description">
                  Տեղեկատվություն
                </span>
                            </div>
                            <div @click="()=>{toggleWidget();$router.push('/articles')}"  class="help-footer-item">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.9795 21.3999H7.70215V19.8003H18.9795V21.3999ZM13.6006 3.80029L12.9004 4.50049L18.8008 10.3003L19.5 9.6001L20.6006 10.6997L15.4004 15.8999L14.3008 14.8003L15 14.1001L12.6006 11.6997L4.5 19.8003L3.40039 18.6997L11.5 10.6001L9.10059 8.30029L8.40039 9.00049L7.30078 7.8999L12.5 2.6001L13.6006 3.80029ZM10.2002 7.1001L16.1006 12.8999L17.6006 11.3999L11.8008 5.6001L10.2002 7.1001Z" fill="#006BE6"/>
                                </svg>
                                <span class="help-description">
                  Ինչպես մասնակցել տենդերների
                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <!-- Image Modal -->
        <transition name="modal-fade">
            <div v-if="imageModal.show" class="image-modal-overlay" @click="closeImageModal">
                <div class="image-modal" @click.stop>
                    <button class="modal-close" @click="closeImageModal">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 1L1 13M1 1L13 13" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                    <img :src="imageModal.src" alt="Մեծացված պատկեր" class="modal-image">
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'HelpWidget',
    data() {
        return {
            isOpen: false,
            loading: false,
            questions: [],
            activeQuestion: null,
            hasUnreadQuestions: false,
            imageModal: {
                show: false,
                src: ''
            }
        }
    },
    mounted() {
        // Add click outside listener
    },
    beforeDestroy() {
        // Remove click outside listener
    },
    methods: {
        async loadQuestions() {
            this.loading = true;
            try {
                let currentUrl = this.$route.fullPath;
                if (currentUrl !== '/') {
                    currentUrl = currentUrl.replace(/\/$/, '');
                }
                const response = await this.$client.get('/help-questions', {
                    params: { url: currentUrl }
                });
                this.questions = response.data.questions || [];
                this.hasUnreadQuestions = this.questions.length > 0;
            } catch (error) {
                console.error('Error loading help questions:', error);
                this.questions = [];
            } finally {
                this.loading = false;
            }
        },

        toggleWidget() {
            this.isOpen = !this.isOpen;
            if (this.isOpen) {
              this.loadQuestions();
            }
        },

        closeWidget() {
            this.isOpen = false;
            this.activeQuestion = null;
        },

        toggleQuestion(index) {
            this.activeQuestion = this.activeQuestion === index ? null : index;
        },

        formatText(text) {
            return text.replace(/\n/g, '<br>');
        },

        openImageModal(src) {
            this.imageModal.src = src;
            this.imageModal.show = true;
        },

        closeImageModal() {
            this.imageModal.show = false;
            this.imageModal.src = '';
        }
    }
}
</script>

<style scoped>
.help-widget, .help-close-button {
    position: fixed;
    z-index: 9999;
}

/* Help Button with Thick Animated Background */
.help-button {
    position: fixed;
    bottom: 20px;
    left: 20px;
    width: 52px;
    height: 52px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.help-button:hover {
    transform: scale(1.05);
}
.help-close-button{
    position: fixed;
    bottom: 20px;
    left: 20px;
    width: 52px;
    height: 52px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}
.help-close-button:hover {
    transform: scale(1.05);
}
/* Background Circles - Thick Animation */
.background-circles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.circle {
    position: absolute;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.circle-1 {
    width: 52px;
    height: 52px;
    background: #00BFA5;
    animation: pulse1 3s ease-in-out infinite;
}

.circle-2 {
    width: 44px;
    height: 44px;
    background: #00BFA5;
    animation: pulse2 3s ease-in-out infinite 0.5s;
}

.circle-3 {
    width: 36px;
    height: 36px;
    background: #00BFA5;
    animation: pulse3 3s ease-in-out infinite 1s;
}

.circle-4 {
    width: 52px;
    height: 52px;
    background: black;
    border-top-right-radius: 8px !important;
}

/* Help Icon */
.help-icon {
    position: relative;
    z-index: 10;
    color: white;
    font-weight: bold;
}

/* Notification Badge */
.notification-badge {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 16px;
    height: 16px;
    background: #ff4444;
    border-radius: 50%;
    border: 3px solid white;
    z-index: 15;
}

/* Pulsing Effect */
.pulsing .circle-1 {
    animation: pulsing 2s ease-in-out infinite;
}

/* Help Panel */
.help-panel {
    position: fixed;
    bottom: 88px;
    left: 20px;
    width: 688px;
    max-height: 1000px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.help-panel-container{
    display: flex;
    flex-direction: column;
    height: -webkit-fill-available;
}

.help-header {
    padding: 32px 40px;
    display: flex;
    flex-direction: column;
}

.help-title {
    margin: 0;
    font-size: 26px;
    font-weight: 700;
    color: rgba(14, 15, 18, 1);
}

.help-description {
    font-size: 16px;
    font-weight: 400;
    color: rgba(89, 94, 107, 1);
}

.close-btn {
    background: rgba(0, 0, 0, 0.2);
    border: none;
    color: white;
    cursor: pointer;
    padding: 8px;
    border-radius: 50%;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
}

.close-btn:hover {
    background: rgba(0, 0, 0, 0.3);
}

.help-content-container {
    flex: 1;
    overflow-y: auto;
    max-height: 450px;
    padding: 0 20px ;
}
.help-content .card{
    box-shadow: none;
    border: 1px solid rgba(237, 239, 242, 1);
}
/* Loading State */
.loading-state {
    text-align: center;
    padding: 40px 20px;
    color: #666;
}

.spinner {
    width: 32px;
    height: 32px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #00BFA5;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 15px;
}

.no-questions {
    text-align: center;
    padding: 40px 20px;
    color: #666;
}

.no-questions i {
    font-size: 36px;
    margin-bottom: 15px;
    color: #ddd;
}

/* Questions List */
.questions-list {
    padding: 0;
}

.question-item {
    border-bottom: 1px solid #f0f0f0;
}

.question-item:last-child {
    border-bottom: none;
}

.question-header {
    padding: 18px 20px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.2s;
}

.question-header:hover {
    background-color: #f9f9f9;
}

.question-item.active .question-header {
    background-color: #e8f5e9;
    color: #2e7d32;
}

.question-text {
    font-weight: 500;
    flex: 1;
    margin-right: 15px;
    line-height: 1.5;
    font-size: 15px;
    color: #333;
}

.toggle-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
}

.toggle-icon {
    transition: transform 0.3s ease;
}

.toggle-icon.rotated {
    transform: rotate(180deg);
}

.question-answer {
}

.answer-text {
    margin-bottom: 15px;
    line-height: 1.6;
    color: #555;
    font-size: 14px;
    max-width: 100%;
}

.answer-text p {
    margin: 0;
}

/* Media Content */
.answer-media {
    margin-top: 15px;
}

.media-item {
    margin-bottom: 15px;
}

.media-item:last-child {
    margin-bottom: 0;
}

.answer-image {
    max-width: 100%;
    height: auto;
    border-radius: 8px;
    cursor: pointer;
    transition: transform 0.2s;
    border: 1px solid #ddd;
}

.answer-image:hover {
    transform: scale(1.02);
}

.answer-video {
    width: 100%;
    max-height: 200px;
    border-radius: 8px;
}

.answer-audio {
    width: 100%;
}

/* Help Footer */
.help-footer {
    padding: 14px 20px;
    border-top: 1px solid #eee;
    text-align: center;
}

.help-footer-title{
    display: flex;
    font-size: 16px;
    color: rgba(14, 15, 18, 1);
    font-weight: 600;
}

.help-footer-item{
    display: flex;
    padding: 4px 16px;
    font-size: 14px;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    transition: .2s ease-in-out;
}

.help-footer-item:hover *{
    color: #0a6edb;
}

/* Image Modal */
.image-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
}

.image-modal {
    position: relative;
    max-width: 90%;
    max-height: 90%;
    background: white;
    border-radius: 12px;
    overflow: hidden;
}

.modal-image {
    width: 100%;
    height: auto;
    display: block;
}

.modal-close {
    position: absolute;
    top: 15px;
    right: 15px;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    border: none;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Animations */
@keyframes pulse1 {
    0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
    50% { transform: translate(-50%, -50%) scale(1.2); opacity: 0.8; }
}

@keyframes pulse2 {
    0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 0.8; }
    50% { transform: translate(-50%, -50%) scale(1.3); opacity: 0.6; }
}

@keyframes pulse3 {
    0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 0.6; }
    50% { transform: translate(-50%, -50%) scale(1.4); opacity: 0.4; }
}

@keyframes pulsing {
    0%, 100% { transform: translate(-50%, -50%) scale(1); }
    50% { transform: translate(-50%, -50%) scale(1.15); }
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* Transitions */
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}

.slide-up-enter-active, .slide-up-leave-active {
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.slide-up-enter, .slide-up-leave-to {
    transform: translateY(100px);
    opacity: 0;
}

.expand-enter-active, .expand-leave-active {
    transition: all 0.3s ease;
    overflow: hidden;
}

.expand-enter, .expand-leave-to {
    max-height: 0;
    opacity: 0;
}

.expand-enter-to, .expand-leave {
    max-height: 1000px;
    opacity: 1;
}

.modal-fade-enter-active, .modal-fade-leave-active {
    transition: opacity 0.3s ease;
}

.modal-fade-enter, .modal-fade-leave-to {
    opacity: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
    .help-panel {
        width: calc(100vw - 40px);
        max-width: 400px;
    }

    .circle-1 { width: 52px; height: 52px; }
    .circle-2 { width: 44px; height: 44px; }
    .circle-3 { width: 36px; height: 36px; }
}

@media (max-width: 480px) {

    .help-content-container{
        height: 100%;
    }

    .help-header{
        padding: 16px 20px;
    }

    .help-title{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .help-panel {
        max-width: 100vw;
        max-height: 100vh;
        width: 100vw;
        height: 100vh;
        left: 0;
        bottom: 0;
        top: 0;
        right: 0;
        border-radius: 0;
        z-index: 99999;
    }

    .help-button, .help-close-button {
        bottom: 20px;
        left: 20px;
        width: 44px;
        height: 44px;
    }

    .circle-1 { width: 44px; height: 44px; }
    .circle-2 { width: 36px; height: 36px; }
    .circle-3 { width: 28px; height: 28px; }
}
</style>

<style scoped>
.text-distance{
    margin-top: 16px;
    margin-bottom: 30px;
}
.help-content-more-arrow{
    transform: rotate(90deg);
    transition: all 0.5s linear;
}
.help-content{
    background: #F7F7F7 !important;
    cursor: pointer;
    border: 0 !important;
    border-radius: 12px;
}
.help-block{
    margin: 50px 0 60px;
}
.help-content-block{
    background: #F7F7F7;
    margin-bottom: 12px;
    padding: 16px;
}
.help-content-block:last-child{
    margin-bottom: 0;
}
.help-content-header{
    color: #2D3036;
    font-size: 18px;
    line-height: 26px;
    transition: all 0.5s linear;
}
.help-content-text{
    color: #595E6B;
    font-size: 16px;
    line-height: 24px;
    background-color: white;
    border: 1px solid #EDEFF2;
    padding: 20px;
    border-radius: 0 0 12px 12px;
}
.help-content-main-block{
    padding: 16px;
}
[aria-expanded="true"] .help-content-header.active{
    color: #0065D9;
}
[aria-expanded="true"] .help-content-more-arrow.active{
    transform: rotate(270deg);
}



@media only screen and (max-width: 1200px) {
}
</style>
<style>
.answer-text *{
    max-width: 100%;
}
</style>
